import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";

import solarImg from "../../assets/media/ImageAnekant/solar.png";
import cogenImg from "../../assets/media/ImageAnekant/cogen.png";
import powerImg from "../../assets/media/ImageAnekant/power.png";



/* Banner data */
const banners = [
  {
    title: "Solar, Wind & Cogen Power",
    subtitle: "Solutions for a Sustainable Future",
    desc:
      "Leading the way in renewable energy solutions with state-of-the-art power plants.",
    image: solarImg,
    link: "/renewableenergyindia",
  },
  {
    title: "High Efficiency",
    subtitle: "Cogeneration Power Plants",
    desc:
      "Explore cogeneration plants delivering power and heat with maximum efficiency.",
    image: cogenImg,
    link: "/cogeneration",
  },
  {
    title: "Reliable & Scalable",
    subtitle: "Power Generation Solutions",
    desc:
      "Thermal and conventional power plants powering industries nationwide.",
    image: powerImg,
    link: "/powergenerationplants",
  },
];

function Header() {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
  };

  return (
    <section className="energo-hero-carousel">
      <Slider {...settings}>
        {banners.map((item, index) => (
          <div key={index}>
            <div
              className="energo-hero-slide"
              style={{ backgroundImage: `url(${item.image})` }}
            >
              <div className="container-fluid px-lg-5">
                <div className="row align-items-center min-vh-75">
                  <div className="col-lg-6 col-md-8 hero-content">
                    <h1>
                      {item.title}
                      <span>{item.subtitle}</span>
                    </h1>
                    <p>{item.desc}</p>

                    <Link to={item.link} className="btn hero-btn">
                      Learn More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default Header;
